import { cx } from "@ui/utils/cx";
import type { ReactNode } from "react";

export interface FullBleedProps {
  children: ReactNode;
  className?: string;
}

export function FullBleed({ children, className }: FullBleedProps) {
  return <div className={cx("-mx-5 md:mx-0", className)}>{children}</div>;
}
